import _flowRight from 'lodash/flowRight';
import { normalize } from 'normalizr';
import { getPRWorkOrders } from '@homeservices/api-kit/workorder/proreferral';
import { toSnakeCase } from '@/utils/to-snake-case';
import { WORK_ORDERS_SCHEMA } from '@/store/modules/entities';
import { withTakeLatest } from '@/utils/cancel-token';
import {
  withRequestLifecycle,
  REQUEST_LIFECYCLE,
} from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchWorkOrder';

export default {
  namespaced: true,
  state: {
    current: {
      status: REQUEST_LIFECYCLE.UNINITIALIZED,
      error: null,
      result: '',
    },
  },
  getters: {
    currentWorkOrderMeta: (state) => {
      const { result, ...meta } = state.current;

      return meta;
    },
    currentRawWorkOrder: state => state.current.result,
  },
  actions: {
    fetchWorkOrder: _flowRight(
      withTakeLatest('jobId'),
      withRequestLifecycle(MUTATION_KEY)
    )(
      async (
        { dispatch },
        { injected: { cancelToken, performFulfillment, performSideEffect },
          jobId, orderHash, includePublicProfiles }
      ) => {
        // Build the query parameters based on what's provided
        const queryParams = {};

        if (jobId) {
          queryParams.userFriendlyIdentifier = jobId;
        }

        if (orderHash) {
          queryParams.orderHash = orderHash;
        }

        // If neither is provided, throw an error
        if (!jobId && !orderHash) {
          throw new Error('Either jobId or orderHash must be provided');
        }

        const { data: { results } } = await getPRWorkOrders(
          toSnakeCase(queryParams),
          cancelToken);
        if (includePublicProfiles) {
          performSideEffect(() =>
            dispatch(
              'dashboard/publicProfiles/fetchPublicProfiles',
              {
                bucketName: 'workOrders',
                params: {
                  service_provider_identifiers: Object.values(results[0].matches).map(
                    ({ service_provider_user_identifier }) => service_provider_user_identifier
                  ).join(','),
                  size: 100,
                },
              },
              { root: true }
            )
          );
        }

        return performFulfillment(normalize(results, [WORK_ORDERS_SCHEMA]));
      }
    ),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      state.current = {
        ...state.current,
        ...payload,
      };
    },
  },
};
